import {
  WARRANTY_UPDATE_NAME,
  WARRANTY_UPDATE_SURNAME,
  WARRANTY_UPDATE_SINISTER_ADDRESS,
  WARRANTY_UPDATE_EMAIL,
  WARRANTY_UPDATE_SINISTER_DATE,
  WARRANTY_UPDATE_SCORE_ASK,
  WARRANTY_UPDATE_VALIDATE_CONTRACT,
  WARRANTY_UPDATE_POLICE,
  WARRANTY_UPDATE_INMOBILIER,
  WARRANTY_UPDATE_EMBELLISSEMENT,
  WARRANTY_UPDATE_MOBILIER,
  WARRANTY_UPDATE_PISCINE,
  WARRANTY_UPDATE_EXTERIEUR,
  WARRANTY_UPDATE_CURRENT_CLAIM,
  WARRANTY_UPDATE_LITIGATION_ALERT_ABSENCE,
  WARRANTY_UPDATE_GAG_NUMBER,
  WARRANTY_UPDATE_REN_NUMBER,
  WARRANTY_UPDATE_SINISTER_CAUSE,
  WARRANTY_UPDATE_SINISTER_PLACE,
  WARRANTY_UPDATE_DAMAGE_PLACE,
  WARRANTY_UPDATE_CAUSE_REPAIRED,
  WARRANTY_UPDATE_THIRD_PARTY_INVOLVED
} from '@/store/types'

export default {
  [WARRANTY_UPDATE_NAME](state, payload) {
    state.name = payload
  },
  [WARRANTY_UPDATE_SURNAME](state, payload) {
    state.surname = payload
  },
  [WARRANTY_UPDATE_SINISTER_ADDRESS](state, payload) {
    state.sinisterAddress = payload
  },
  [WARRANTY_UPDATE_EMAIL](state, payload) {
    state.email = payload
  },
  [WARRANTY_UPDATE_SINISTER_DATE](state, payload) {
    state.sinisterDate = payload
  },
  [WARRANTY_UPDATE_POLICE](state, payload) {
    state.police = payload
  },
  [WARRANTY_UPDATE_SCORE_ASK](state, payload) {
    state.scoreAsk = payload
  },
  [WARRANTY_UPDATE_VALIDATE_CONTRACT](state, payload) {
    state.validateContract = payload
  },
  [WARRANTY_UPDATE_INMOBILIER](state, payload) {
    state.inmobiliere = payload
  },
  [WARRANTY_UPDATE_EMBELLISSEMENT](state, payload) {
    state.embellissement = payload
  },
  [WARRANTY_UPDATE_MOBILIER](state, payload) {
    state.mobiliere = payload
  },
  [WARRANTY_UPDATE_PISCINE](state, payload) {
    state.piscine = payload
  },
  [WARRANTY_UPDATE_EXTERIEUR](state, payload) {
    state.exterieur = payload
  },
  [WARRANTY_UPDATE_CURRENT_CLAIM](state, payload) {
    state.currentClaim = payload
  },
  [WARRANTY_UPDATE_LITIGATION_ALERT_ABSENCE](state, payload) {
    state.litigationAlertAbsence = payload
  },
  [WARRANTY_UPDATE_GAG_NUMBER](state, payload) {
    state.gagNumber = payload
  },
  [WARRANTY_UPDATE_REN_NUMBER](state, payload) {
    state.renNumber = payload
  },
  [WARRANTY_UPDATE_SINISTER_CAUSE](state, payload) {
    state.sinisterCause = payload
  },
  [WARRANTY_UPDATE_SINISTER_PLACE](state, payload) {
    state.sinisterPlace = payload
  },
  [WARRANTY_UPDATE_DAMAGE_PLACE](state, payload) {
    state.damagePlace = payload
  },
  [WARRANTY_UPDATE_CAUSE_REPAIRED](state, payload) {
    state.causeRepaired = payload
  },
  [WARRANTY_UPDATE_THIRD_PARTY_INVOLVED](state, payload) {
    state.thirdPartyInvolved = payload
  }
}
